export default "__VITE_ASSET__DJ2LXD$R__"